import styled from "styled-components";

import { theme } from "../../../styles/theme";

export const Container = styled.div`
  grid-area: sidebar;
  width: 100%;
  display: flex;
  height: 100vh;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${theme.colors.darkBlue};
  position: relative;

  @media screen and (max-width: 768px) {
    display: none;
  }
`;

export const BaseDash = styled.div`
  position: absolute;
  height: 2px;
  width: calc(100% - 40px);
  background-color: ${theme.colors.blue900};
`;

export const TopDash = styled(BaseDash)`
  top: 10vh;
`;

export const BottomDash = styled(BaseDash)`
  bottom: 2.5vh;
`;

export const Title = styled.span`
  font-family: Poppins;
  color: ${theme.colors.blue100};
  font-weight: 600;
  font-size: 20px;
  margin-top: 30vh;
`;

export const Text = styled.span`
  font-family: Poppins;
  color: ${theme.colors.blue100};
  font-weight: 400;
  font-size: 16px;
  text-align: center;
  position: absolute;
  width: 100%;
  padding: 0 60px;
  bottom: 15vh;
`;
